module.exports = __webpack_public_path__ + "static/media/mail-to.52acc8b8.svg";